import { Model, useRepo } from 'pinia-orm';
import User from './User';
import { useCommonStore } from "../../shared/state/common";

export default class ShareJobCard extends Model {

    static get entity() {
        return 'share_job_cards';
    }

    static fields() {
        return {
            id: this.uid(),
            image_url: this.attr(null),
            price: this.attr(null),
            custom_price: this.attr(null),
            type: this.attr(null),
            type_ref: this.attr(null),
            active: this.boolean(false),
            featured: this.boolean(false),
            unpublished_featured: this.boolean(false),
            tags: this.attr([]),
            has_subscription: this.boolean(false),
            subscription_type: this.attr(null),
            extra: this.attr({}),
            title: this.attr({}),
            unpublished_title: this.attr({}),
            description: this.attr({}),
            unpublished_description: this.attr({}),
            highlight: this.attr({}),
            unpublished_highlight: this.attr({}),
            button_label: this.attr({}),
            unpublished_button_label: this.attr({}),
            order: this.number(0),
        }
    }

    get isFavorited() {
        const commonStore = useCommonStore();
        const user = useRepo(User)
            .with('favoriteCards')
            .where('id', commonStore.currentUserId)
            .first();

        return user.favoriteCards.filter(card => {
            return card.id === this.id;
        }).length > 0;

    }
}
